import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Comp() {
    const { useLang, useState, useRouter, Link } = useGlobal();

    const { t } = useLang('oceanevcharger');
    const { locale } = useRouter();
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1752462500984/ev%20charge%20kv-1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1750904452655/kvh5.jpg',
        title: t('secA_title'),
        desc: t('secA_desc'),
        descColor: '#000',
        titleColor: '#000',
        titleType: 'h1',
    };
    return (
        <div className={styles.comp} >
            <EcoBanner {...dataA} />
        </div>
    );
}
